{
  "search": "Search",
  "login": "Login",
  "firstname": "Firstname",
  "lastname": "Lastname",
  "email": "Email",
  "addUserGroup": "Add group",
  "selectUserProfile": "Select profile",
  "profile": "Profile",
  "userProfile": "User's profile",
  "language": "Language",
  "label": "Name",
  "error": {
    "required": "Field is required",
    "maxLength": "Max length: {maxLength}",
    "invalidFormat": "Invalid format",
    "lowercaseOnly": "Only lowercase is accepted"
  },
  "url": "URL",
  "deleteFile": "Click to delete the file",
  "password": "Password",
  "nominalTemplateName": "Nominal template name",
  "bootstrapTemplateName": "Bootstrap template name",
  "secondIntervalTime": "Interval time (seconds)",
  "profileName": "Profile name",
  "languages": {
    "en": "English",
    "fr": "French (Français)",
    "it": "Italian (Italiano)",
    "es": "Spanish (Español)",
    "de": "German (Deutsch)"
  },
  "passwordPlaceholder": "**********",
  "clickToUpload": "Click to upload",
  "orDragAndDrop": "or drag and drop {format} file only",
  "orDragAndDropWithoutExtension": "or drag and drop",
  "information": {
    "more": "See more information"
  },
  "select": {
    "search": {
      "placeholder": "Search",
      "noResults": "No results"
    }
  },
  "timezone": {
    "placeholder": "Select timezone"
  },
  "selectAll": "Select all",
  "optional": "Optional"
}
